export enum EPopupId {
  PID_OK,
  PID_OK_CANCEL,
  PID_NONE,
}
